/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import {
  PAYMENT_MODE_TYPES_LIST,
  PAYMENT_TYPES_LIST,
} from "../product-container/ProductConstants";
import UserDropDown from "src/business-components/UserDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import LinkComponent from "src/components/LinkComponent";
import { useHistory } from "react-router";
import FormikInput from "src/components/formik/FormikInput";
import { DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { walletEditAction, walletResetAction, walletSearchAction } from "../wallet-container/actions/WalletActions";
import TransactionsPopup from "./TransactionsPopup";

const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    resetForm,
    values,
    activityList,
    onPageChange,
    editClick,
    viewTransactions,
    transactionsModalClass,
    transactionsDisplay,
    agentTransactions,
    closeTransactionsPopup,
  } = props;

  return (
    <div>
      <div style={{ justifyContent: "center", display: "flex", padding: "px" }}>
        <h2>Advance Expense Report</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form autoComplete="disabled">
            <div className="form-row">
              <div className="form-group col-md-6">
                <label>Agent/User Name</label>
                <UserDropDown name="agentId" value={values.agentId} />
              </div>
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="paymentFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="paymentToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Amount</label>
                <FormikInput
                  name="amount"
                  type="text"
                  placeholder="Enter Amount to be paid"
                  className="form-control"
                  value={values.amount}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Payment Type</label>
                <FormikSelect
                  items={PAYMENT_TYPES_LIST}
                  name="payment_type"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Mode of Payment</label>
                <FormikSelect
                  items={PAYMENT_MODE_TYPES_LIST}
                  name="mode"
                  className="form-control"
                />
              </div>
            </div>
            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                isUpdate={Boolean(values._id)}
                // onSearch={onSearch}
                onClear={onClear}
                resetForm={resetForm}
                values={values}
                submitScope="wallet.wallet_manager.manage.submit"
                searchScope="wallet.wallet_manager.manage.search"
              />
            </div>
          </Form>
          <TransactionsPopup
          transactionsModalClass={transactionsModalClass}
          transactionsDisplay={transactionsDisplay}
          agentTransactions={agentTransactions}
          onClose={closeTransactionsPopup}
          />
        </div>
        <div className="border-top my-3" />
        <div className="card mt-3">
          <div className="card-body">
            {/* <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"Insurance-Renewal-Alert-" + new Date().toLocaleDateString()}
            />
          </h5> */}

            <Table
              recordsPerPage={50}
              onPageChange={onPageChange}
              searchData={{
                data: activityList.data,
                count: activityList.count,
                currentPage: activityList.currentPageIndex,
              }}
              columns={{
                group: [
                  {
                    display: 'Agent/User Name',
                    path: "agentName"
                  },
                  {
                    display: 'Type of Payment',
                    path: "paymentType"
                  },
                  {
                    display: 'Amount',
                    path: "amount"
                  },
                  {
                    display: 'Instrument Number',
                    path: 'instrument_number',
                  },
                  {
                    display: 'Category',
                    path: 'category',
                  },
                  {
                    display: 'Case Code',
                    path: 'caseCode',
                  },
                  {
                    display: 'Pay Date',
                    type: Date,
                    format: DATE_TIME_FORMAT.DATE,
                    path:"paidOn"
                  },
                  {
                    display: 'Remarks',
                    path: "remarks"
                  },
                  {
                    display: 'By',
                    path: 'by.personalInfo.firstName',
                  },
                  {
                    display: 'Updated By',
                    path: 'updatedBy.personalInfo.firstName',
                  },
                  {
                    display: 'Ts',
                    type: Date,
                    format: DATE_TIME_FORMAT.TIMEAGO,
                    path:'ts'
                  },
                  {
                    display: 'Updated Ts',
                    type: Date,
                    format: DATE_TIME_FORMAT.TIMEAGO,
                    path:'updatedTs'
                  },
                ],
              }}
              customActions={[
                {
                  heading: "Edit Payment",
                  Render: ({ record }) => {
                    return (
                      <LinkComponent onClick={() => editClick(record)}>
                        <i className="fas fa-pen" />
                      </LinkComponent>
                    );
                  },
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  values: PropTypes.any.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
};

const AdvanceExpense = () => {

  const [filterInitialValues, setFilterInitialValues] = useState({
    ...filterDefaultValues,
  });
  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [transactionsDisplay, setTransactionsDisplay] = useState(false)
  const [transactionsModalClass, setTransactionsModalClass] = useState(false);
  const [agentTransactions, setAgentTransactions] = useState([])

  // REDUX
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.WalletReducer, shallowEqual);

  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );

  const extractTransactions = (walletPaymentDoc) => {
    if (!walletPaymentDoc || !walletPaymentDoc.transactions) {
      return { transactions: [], totalAmount: 0 };
    }
  
    let totalAmount = 0;
  
    const transactions = walletPaymentDoc.transactions.map(transaction => {
      totalAmount += transaction.amount;
      return {
        date: transaction.date,
        amount: transaction.amount,
        case_id: transaction.case_id,
        payment_no: transaction.payment_no
      };
    });
  
    return { transactions, totalAmount };
  };
  
  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }
  
    const PrepairData = [];
  
    searchResults.forEach((payInfo) => {
      const agentName =
        payInfo.agentId.personalInfo.firstName +
        " " +
        payInfo.agentId.personalInfo.lastName +
        "-" +
        payInfo.agentId.employmentType;
  
      const paidOn = payInfo.payment_date;
      const paymentType = payInfo.payment_type;
      const amount = payInfo.amount;
      const mode = payInfo.mode;
      const remarks = payInfo.remarks;
      const category=payInfo.category;
      const caseCode=payInfo.caseCode;
      // const { transactions, totalAmount } = extractTransactions(payInfo);
  
      PrepairData.push({
        ...payInfo,
        agentName,
        paidOn,
        paymentType,
        amount,
        mode,
        remarks,
        category,
        caseCode,
        // transactions,
        // totalAmount,
      });
    });
  
    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
    };
  
    return results;
  }, [searchResults, currentPageIndex]);
  
   
  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        walletSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      walletSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values, formikUtils) => {
      formikUtils.setSubmitting(false);
      const {
        agentId,
        paymentFromDate,
        paymentToDate,
        amount,
        payment_type,
        mode
      } = values;

      // Check if paymentFromDate and paymentToDate are present
      if (!paymentFromDate || !paymentToDate) {
        dispatch(
          headerShowAction({
            data: "paymentFromDate and paymentToDate are required filters.",
          })
        );
        return;
      }

      let where = {};

      if (agentId) {
        set(where, "agentId", agentId)
      }
      if (amount) {
        set(where, "amount", amount)
      }
      if (payment_type) {
        set(where, "payment_type", payment_type);
      }
      // FROM
      if (paymentFromDate && !Number.isNaN(paymentFromDate.getTime())) {
        const fromDate = getStartOfDay(paymentFromDate);
        set(where, "payment_date.$gte", fromDate);
      }

      // TILL
      if (paymentToDate && !Number.isNaN(paymentToDate.getTime())) {
        const tillDate = getEndOfDay(paymentToDate);
        set(where, "payment_date.$lte", tillDate);
      }

      if (mode) {
        where.mode = mode;
      }

      setWhere(where);
      dispatch(
        walletSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );

  const onClear = useCallback(() => {
    dispatch(walletResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const viewTransactions = (data) => {
    const transactions = data?.transactions ?? [];

    setTransactionsDisplay("block");
    setTransactionsModalClass("show");
    setAgentTransactions(transactions);
  };
  
  //CLOSE Transaction popup
  const closeTransactionsPopup = () => {
    setTransactionsDisplay(false);
    setTransactionsModalClass(false);
    setAgentTransactions([]);
  };

  // EDIT
  const editClick = useCallback(
    (record) => {
      dispatch(walletEditAction(record));
      history.push(RoutingUtil.walletManagerUrl());
    },
    [dispatch, walletEditAction, history]
  );

  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
      // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            activityList={activitiesFromSearch}
            userType={userType}
            // ExportInExcel={ExportInExcel}
            // handleChange={handleChange}
            // generateInvoice={generateInvoice}
            history={history}
            onPageChange={onPageChange}
            // viewRemarks={viewRemarks}
            editClick={editClick}
            viewTransactions={viewTransactions}
            transactionsDisplay={transactionsDisplay}
            transactionsModalClass={transactionsModalClass}
            agentTransactions={agentTransactions}
            closeTransactionsPopup = {closeTransactionsPopup}
          />
        )}
      </Formik>
    </div>
  );
};

export default AdvanceExpense;
